// Field schemas for the generic admin content manager
const FAQ_CATS = ["general", "booking", "pricing", "temple", "whatsapp"];
const POOJA_CATS = ["health", "marriage", "career", "dosha", "family", "temple"];
const ICONS = ["Heart", "Activity", "Briefcase", "Sparkles"];

export const CONTENT_CONFIG = {
  poojas: {
    title: "Poojas",
    singular: "Pooja",
    titleField: "name",
    subtitleField: "category",
    fields: [
      { key: "name", label: "Name", type: "text", required: true },
      { key: "slug", label: "Slug (URL)", type: "text", required: true, hint: "e.g. rudrabhishek-pooja-gokarna" },
      { key: "category", label: "Category", type: "select", options: POOJA_CATS },
      { key: "featured", label: "Featured on homepage", type: "checkbox" },
      { key: "short_purpose", label: "Short Purpose", type: "textarea" },
      { key: "suitable_for", label: "Suitable For", type: "text" },
      { key: "full_description", label: "Full Description", type: "textarea", big: true },
      { key: "price", label: "Starting Price (₹)", type: "number" },
      { key: "price_note", label: "Price Note", type: "text" },
      { key: "duration", label: "Duration", type: "text" },
      { key: "when_performed", label: "When Performed", type: "text" },
      { key: "trust_note", label: "Trust Note", type: "textarea" },
      { key: "benefits", label: "Benefits", type: "list" },
      { key: "who_should_do", label: "Who Should Do This", type: "list" },
      { key: "required_details", label: "Required Details", type: "list" },
      { key: "what_included", label: "What's Included", type: "list" },
      { key: "process_steps", label: "Process Steps", type: "list" },
      { key: "images", label: "Images", type: "images" },
      { key: "pooja_faqs", label: "Pooja FAQs", type: "faqlist" },
      { key: "meta_title", label: "SEO Meta Title", type: "text" },
      { key: "meta_description", label: "SEO Meta Description", type: "textarea" },
    ],
  },
  guidance: {
    title: "Guidance Pages",
    singular: "Guidance Page",
    titleField: "title",
    subtitleField: "slug",
    fields: [
      { key: "title", label: "Title", type: "text", required: true },
      { key: "slug", label: "Slug (URL)", type: "text", required: true },
      { key: "icon", label: "Icon", type: "select", options: ICONS },
      { key: "problem_description", label: "Problem Description", type: "textarea" },
      { key: "content", label: "Content", type: "textarea", big: true },
      { key: "recommended_pooja_slugs", label: "Recommended Pooja Slugs", type: "list", hint: "One pooja slug per line" },
      { key: "meta_title", label: "SEO Meta Title", type: "text" },
      { key: "meta_description", label: "SEO Meta Description", type: "textarea" },
    ],
  },
  blogs: {
    title: "Blog Posts",
    singular: "Blog Post",
    titleField: "title",
    subtitleField: "category",
    fields: [
      { key: "title", label: "Title", type: "text", required: true },
      { key: "slug", label: "Slug (URL)", type: "text", required: true },
      { key: "category", label: "Category", type: "text" },
      { key: "author", label: "Author", type: "text" },
      { key: "published", label: "Published", type: "checkbox" },
      { key: "excerpt", label: "Excerpt", type: "textarea" },
      { key: "cover_image", label: "Cover Image", type: "image-single" },
      { key: "content", label: "Content (Markdown)", type: "textarea", big: true, hint: "Use ## for headings, - for bullets, **bold**" },
      { key: "meta_title", label: "SEO Meta Title", type: "text" },
      { key: "meta_description", label: "SEO Meta Description", type: "textarea" },
    ],
  },
  faqs: {
    title: "FAQs",
    singular: "FAQ",
    titleField: "question",
    subtitleField: "category",
    fields: [
      { key: "question", label: "Question", type: "text", required: true },
      { key: "answer", label: "Answer", type: "textarea" },
      { key: "category", label: "Category", type: "select", options: FAQ_CATS },
    ],
  },
  testimonials: {
    title: "Testimonials",
    singular: "Testimonial",
    titleField: "name",
    subtitleField: "location",
    fields: [
      { key: "name", label: "Name", type: "text", required: true },
      { key: "location", label: "Location", type: "text" },
      { key: "rating", label: "Rating (1-5)", type: "number" },
      { key: "text", label: "Testimonial", type: "textarea" },
      { key: "featured", label: "Featured", type: "checkbox" },
    ],
  },
};
